import { type ReactNode } from 'react';
import { Link } from 'react-router-dom';
import './DeveloperPortalLayout.css';

interface DeveloperPortalLayoutProps {
  children: ReactNode;
}

function DeveloperPortalLayout({ children }: DeveloperPortalLayoutProps) {
  return (
    <div className="dev-portal-layout">
      <header className="dev-portal-layout__topbar">
        <Link to="/" className="dev-portal-layout__logo" aria-label="SkillBubble home">
          <span className="dev-portal-layout__logo-mark">SB</span>
          <span className="dev-portal-layout__logo-text">SkillBubble</span>
        </Link>
        <Link to="/app" className="dev-portal-layout__back-link">
          ← Back to app
        </Link>
      </header>
      <main id="main-content" className="dev-portal-layout__content" tabIndex={-1}>
        {children}
      </main>
    </div>
  );
}

export default DeveloperPortalLayout;
